import React from 'react'
import PropTypes from 'prop-types';
import {Image} from '@salesforce/retail-react-app/app/components/shared/ui';
import {Swiper, SwiperSlide} from 'swiper/react'
import {A11y} from 'swiper/modules'
import {useBreakpointValue} from '@chakra-ui/react'

const PhotoSlider = ({review, setSelectedReview}) => {
    const slideWidth = useBreakpointValue({base: '53px', lg: '100px'})
    const handlePhotoClick = (index, event) => {
        setSelectedReview({review, index, triggerElement: event?.currentTarget || null});
    }
    return (
        <Swiper
            modules={[A11y]}
            a11y={{
                enabled: true
            }}
            spaceBetween={1}
            slidesPerView={'auto'}
            freeMode={true}>
            {review?.Photos.map((photo, index) => {
                return (
                    <SwiperSlide key={index} style={{width: slideWidth}}>
                        <Image cursor={'pointer'}
                            onClick={(e) => handlePhotoClick(index, e)}
                            onKeyDown={(e) => e.key === 'Enter' && handlePhotoClick(index, e)}
                            role="button"
                            _focusVisible={{
                                margin: '3px'
                            }}
                            tabIndex={0}
                            w="100%"
                            src={photo?.Sizes?.normal?.Url || photo?.Sizes?.thumbnail?.Url}
                            alt="Review image"
                            aria-label="Open review" />
                    </SwiperSlide>
                );
            })}
        </Swiper>
    )
}

PhotoSlider.photos = {
    review: PropTypes.object.isRequired,
    setSelectedReview: PropTypes.func
};

export default PhotoSlider;
